// Types
import { ERoute, type TFeature, type TNavLink } from '~/modules/dashboard/types';
import { EFeatureName } from '~/misc/feature/types';
import { EAnalyticsEvent } from '~/misc/services/analytics/types';

const NAV_LINKS: TNavLink[] = [
  {
    title: 'Usage dashboard',
    to: '/admin/dashboard',
  },
  {
    title: 'User management',
    to: '/admin/users',
  },
  {
    title: 'Talking points',
    to: '/admin/talking-points',
  },
  {
    title: 'Address imports',
    to: '/admin/address-imports',
  },
  // TODO: once all /admin/roi components are moved to the /admin/dashboard remove this entry
  // {
  //   title: 'ROI dashboard',
  //   to: '/admin/roi',
  // },
  // TODO: uncomment when matching system is ready
  // {
  //   title: 'Import CSV',
  //   to: '/admin/import',
  // },
];

const FEATURES_OBJECT: Record<ERoute, TFeature | undefined> = {
  [ERoute.NEW]: {
    title: 'Market Success',
    to: { name: ERoute.NEW },
    hasDepartments: true,
    analyticsEvent: EAnalyticsEvent.DASHBOARD_SIDEBAR_TOOLS_MARKET_SUCCESS_CLICKED,
  },
  [ERoute.ON_MARKET]: {
    title: 'On-Market',
    to: { name: ERoute.ON_MARKET },
    hasDepartments: true,
    analyticsEvent: EAnalyticsEvent.DASHBOARD_SIDEBAR_TOOLS_ON_MARKET_CLICKED,
  },
  [ERoute.ANNIVERSARY]: {
    title: 'Anniversary',
    to: { name: ERoute.ANNIVERSARY },
    privateName: EFeatureName.OPPORTUNITY_SEARCH_ANNIVERSARY,
    analyticsEvent: EAnalyticsEvent.DASHBOARD_SIDEBAR_TOOLS_ANNIVERSARY_CLICKED,
  },
  [ERoute.DOWNLOAD]: {
    title: 'Market Download',
    to: { name: ERoute.DOWNLOAD },
    privateName: EFeatureName.DOWNLOAD_MARKET_DATA,
    hasDepartments: false,
    analyticsEvent: EAnalyticsEvent.DASHBOARD_SIDEBAR_TOOLS_MARKET_DOWNLOAD_CLICKED,
  },
  [ERoute.WITHDRAWN]: {
    title: 'Withdrawn',
    to: { name: ERoute.WITHDRAWN },
    privateName: EFeatureName.OPPORTUNITY_SEARCH_WITHDRAWN,
    hasDepartments: true,
    analyticsEvent: EAnalyticsEvent.DASHBOARD_SIDEBAR_TOOLS_WITHDRAWN_CLICKED,
  },
  [ERoute.LIKELY_SOLD]: {
    title: 'Likely Sold',
    to: { name: ERoute.LIKELY_SOLD },
    privateName: EFeatureName.OPPORTUNITY_SEARCH_LIKELY_SOLD,
    hasDepartments: true,
    analyticsEvent: EAnalyticsEvent.DASHBOARD_SIDEBAR_TOOLS_LIKELY_SOLD_CLICKED,
  },
  [ERoute.AUTOMATED_EMAIL]: {
    title: 'Automated Email',
    to: { name: ERoute.AUTOMATED_EMAIL },
    privateName: EFeatureName.AUTOMATED_EMAIL,
    hasDepartments: true,
    analyticsEvent: EAnalyticsEvent.DASHBOARD_SIDEBAR_TOOLS_AUTOMATED_EMAIL_CLICKED,
  },
};

const FEATURES: TFeature[] = Object.values(FEATURES_OBJECT).filter(
  (item: TFeature | undefined) => item !== undefined
) as TFeature[];

export { NAV_LINKS, FEATURES, FEATURES_OBJECT };
